export function filterAndJoin(strings, glue, emptyString = '', emptyResult = '') {
	const resultString = strings.filter(str => typeof str !== 'undefined' && str !== null && str.trim() !== '' && str.trim() !== emptyString).join(glue);
	return resultString === '' ? emptyResult : resultString;
}
